// src/components/App/Performance/DailyPerfCumRow.js

import React, { Component, Fragment } from 'react';
import './PerformanceRow.css';

function calcReturnsAnnualized(dates, levels) {
  if (!dates?.length || !levels?.length) {
    return null;
  }

  const startDate = new Date(dates[0]);
  const endDate = new Date(dates[dates.length - 1]);
  const diffDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

  const startNAV = levels[0];
  const endNAV = levels[levels.length - 1];
  const ror_cumu = (endNAV - startNAV) / startNAV;

  if (diffDays >= 365) {
    const years = diffDays / 365.0;
    return Math.pow(1 + ror_cumu, 1.0 / years) - 1;
  } else {
    return ror_cumu;
  }
}

class DailyPerfCumRow extends Component {
  formatPercent(number) {
    return number !== null ? `${(number * 100).toFixed(2)}%` : '-';
  }

  formatDecimal(number) {
    return number !== null ? `${number.toFixed(2)}%` : '-';
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' });
  }

  render() {
    const { fund } = this.props;
    if (!fund?.nav10Knav || !fund?.nav10Kdates || fund.nav10Knav.length < 2) {
      return null;
    }

    const nav = fund.nav10Knav;     // normalized Growth of 10k for the visible window (starts at 10,000)
    const dates = fund.nav10Kdates; // dates aligned to that normalized window

    // Cumulative return over the visible window (point-to-point)
    const ror_cumu = (nav[nav.length - 1] - nav[0]) / nav[0];
    // Annualized return matching Python logic
    const ror_ann = calcReturnsAnnualized(dates, nav);

    const getParsedFundName = (name) => {
      const parts = name.split(' - ');
      return parts.length > 1 ? parts[0] : name;
    };

    return (
      <Fragment>
        <tr className='greyline'>
          <td width='70' className='textLeft'>
            {(() => {
              switch (fund.fundType) {
                case 'BMK':
                  return fund.name.toUpperCase();
                case 'BLEND':
                case 'COD':
                  return "-";
                default:
                  return fund.fundPageURL ? (
                    <a className='tickerLink' href={fund.fundPageURL} target='_new' rel='noreferrer'>
                      {getParsedFundName(fund.name)}
                    </a>
                  ) : (
                    <a className='tickerLink' href={fund.msUrl} target='_new' rel='noreferrer'>
                      {getParsedFundName(fund.name)}
                    </a>
                  );
              }
            })()}
          </td>
          {['BMK', 'WTIDX'].includes(fund.fundType) ? (
            <td width='300' className='textLeft'>
              {fund.fullName.replace(/&amp;/g, '&')}
            </td>
          ) : (
            <td width='300' className='textLeft'>
              {`${fund.fullName.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          )}
          <td className='textCenter'>{this.formatDate(fund.inceptionDate)}</td>
          <td className='textCenter'>
            {fund.type === 'BMK' || ror_cumu === null ? '-' : this.formatDecimal(ror_cumu * 100)}
          </td>
          <td className='textCenter'>
            {fund.type === 'BMK' || ror_ann === null ? '-' : this.formatPercent(ror_ann)}
          </td>
        </tr>
      </Fragment>
    );
  }
}

export default DailyPerfCumRow;
